<template>
  <div class="loader-class">
    <div style="position: relative; width: 100%; height: 100%;">
        <pulse-loader class="pulse-loader-class"  :color='color'></pulse-loader>
    </div>
  </div>
</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'


export default {
  name:"Loader",
  components: {
    PulseLoader
  },
  data: function () {
    return {
        color: '#00a7e1',
        height: '120px',
    }
  },
}
</script>

<style scoped>

  .loader-class{
    position: absolute;
    height: 100vh;
    width: 100vw;
    z-index: 999999;
    background-color:black;
    opacity: 0.6;
  }

  .pulse-loader-class {
    position: absolute;
    left: 50%;
    top: 50%;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/loader.vue